import { defaultHttpClient } from '../../httpClient';

export interface ApplyDiscountsGroup {
  group_type: string;
  sno: number;
  item_key: string;
}

export interface ApplyDiscountsRequest {
  discount_groups: ApplyDiscountsGroup[];
}

export interface ApplyDiscountsResponseGroup {
  group_type: string;
  amount: number;
  item_key: string;
}

export interface ApplyDiscountsResponse {
  sale_discount_rate: number;
  discount_groups: ApplyDiscountsResponseGroup[];
  sale_price: number;
}

export const postApplyDiscounts = (
  goodsSno: number,
  body: ApplyDiscountsRequest,
) => {
  return defaultHttpClient
    .request<ApplyDiscountsResponse>({
      method: 'POST',
      url: `/api/v2/goods/${goodsSno}/apply-discounts/`,
      data: body,
    })
    .then(result => result.data);
};
